export const DOCUMENT_UPLOAD_MAX_BYTES = 20 * 1024 * 1024;
export const DOCUMENT_UPLOAD_MAX_MB = 20;

export const DOCUMENT_UPLOAD_ACCEPT =
  "image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel";

export const DOCUMENT_UPLOAD_SIZE_NOTE =
  "Each file must be less than 20 MB. Zip files are not allowed.";

const BLOCKED_EXTENSIONS = new Set([".zip"]);

const BLOCKED_MIME_TYPES = new Set([
  "application/zip",
  "application/x-zip-compressed",
  "application/x-zip",
]);

function getExtension(name) {
  const normalized = String(name || "").trim().toLowerCase();
  const dotIndex = normalized.lastIndexOf(".");
  return dotIndex >= 0 ? normalized.slice(dotIndex) : "";
}

export function getDocumentUploadValidationError(file) {
  if (!file) return null;

  const extension = getExtension(file.name);
  const mimeType = String(file.type || "").trim().toLowerCase();

  if (BLOCKED_EXTENSIONS.has(extension) || BLOCKED_MIME_TYPES.has(mimeType)) {
    return `"${file.name}" is not allowed. Zip files cannot be uploaded.`;
  }

  if (Number(file.size) > DOCUMENT_UPLOAD_MAX_BYTES) {
    return `"${file.name}" exceeds ${DOCUMENT_UPLOAD_MAX_MB} MB. Each file must be less than ${DOCUMENT_UPLOAD_MAX_MB} MB.`;
  }

  return null;
}

export function filterValidDocumentUploadFiles(files) {
  const incoming = Array.from(files || []);
  const validFiles = [];
  const errors = [];

  incoming.forEach((file) => {
    const error = getDocumentUploadValidationError(file);
    if (error) errors.push(error);
    else validFiles.push(file);
  });

  return { validFiles, errors };
}

export function hasInvalidDocumentUploadFiles(files) {
  return Array.from(files || []).some((file) =>
    Boolean(getDocumentUploadValidationError(file)),
  );
}
